import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import sparkling from "./sparkling.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Title= () => {
  const [topic, setTopic] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [tone, setTone] = useState(null);
  const [customTone, setCustomTone] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [country, setCountry] = useState(null);
  const [countries, setCountries] = useState([]);
  const [apiKeys, setApiKeys] = useState([]);
  const [toneOptions, setToneOptions] = useState([
    { label: "Neutral", value: "neutral", icon: "🤖" },
    { label: "Formal", value: "formal", icon: "🎩" },
    { label: "Friendly", value: "friendly", icon: "😊" },
    { label: "Casual", value: "casual", icon: "😎" },
    { label: "Professional", value: "professional", icon: "💼" },
    { label: "Diplomatic", value: "diplomatic", icon: "🤝" },
    { label: "Confident", value: "confident", icon: "💪" },
    { label: "Academic", value: "academic", icon: "🎓" },
    { label: "Vivid", value: "vivid", icon: "🎨" },
    { label: "Custom...", value: "custom", icon: "⚙️" },
  ]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://countries.dev/countries");
        const countryData = response.data.map((country) => ({
          label: country.name,
          value: country.name,
          languages: Object.values(country.languages || {}).map((lang) => lang.name || lang).join(", "),
          flag: country.flags?.svg || country.flags?.png || "",
        }));
        console.log("[countries.dev] sample record:", response.data?.[0]);
        setCountries(countryData);
      } catch (error) {
        console.error("Error fetching country data:", error?.response?.status, error?.response?.data || error.message);
        toast.error("Failed to fetch country data.");
      }
    };

    const fetchApiKeys = async () => {
      try {
        const response = await axios.get("https://ytubetools.com/api/openaiKey", { timeout: 5000 });
        if (response.status !== 200) {
          throw new Error(`Unexpected response status: ${response.status}`);
        }
        const activeKeys = response.data.filter((key) => key.active);
        if (activeKeys.length === 0) {
          toast.error("No active API keys available.");
        } else {
          setApiKeys(activeKeys);
        }
      } catch (error) {
        console.error("Error fetching API keys:", error.message);
        toast.error(`Error fetching API keys: ${error.message}`);
      }
    };

    fetchCountries();
    fetchApiKeys();
  }, []);

  const handleGenerateResults = async () => {
    if (!topic.trim()) {
      setError("Please write a topic before generating titles.");
      return;
    }
    if (!country) {
      setError("Please select a language.");
      return;
    }
    if (!tone) {
      setError("Please select a tone.");
      return;
    }
  
    setError("");
    setLoading(true);
  
    const language = country.languages || "English";

    try {
      const response = await axios.post("https://tools.videoters.com/api/unified", {
        model: "gpt-5.5",
        messages: [
          {
            role: "system",
            content: `You are an assistant that generates 10 SEO-friendly titles for the topic "${topic}". Titles should be written in ${language} with a ${tone.label || tone} tone.`,
          },
          {
            role: "user",
            content: `Generate exactly 10 distinct and meaningful SEO-friendly titles for the topic "${topic}". Ensure each title is unique and captures attention. Return the titles separated by "###".`,
          },
        ],
        temperature: 0.7,
        max_tokens: 1000,
      });

      if (response.data && response.data.choices && response.data.choices.length > 0) {
        const generatedText = response.data.choices[0].message.content.trim();

        // Split the results into 10 titles using "###"
        let splitResults = generatedText
          .split("###")
          .map((result) => result.trim())
          .filter((result) => result);

        // Ensure exactly 10 titles
        if (splitResults.length < 10) {
          while (splitResults.length < 10) {
            splitResults.push(`Title ${splitResults.length + 1}: Placeholder title.`);
          }
        } else if (splitResults.length > 10) {
          splitResults = splitResults.slice(0, 10);
        }

        setResults(splitResults);
      } else {
        toast.error("No results found in the API response.");
      }
    } catch (error) {
      console.error("[Unified API Error]", error.response?.data || error.message);
      toast.error(`Error: ${error.response?.data?.error?.message || error.message}`);
    }

    setLoading(false);
  };
  






  const handleCustomToneSave = () => {
    if (customTone.trim()) {
      const customOption = { label: customTone, value: customTone.toLowerCase(), icon: "⚙️" };
      toneOptions.push(customOption);
      setTone(customOption);
      setShowModal(false);
      setCustomTone("");
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied to clipboard!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          theme: "colored",
        });
      })
      .catch(() => {
        toast.error("Failed to copy!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          theme: "colored",
        });
      });
  };

  return (
    <div className="container">
      <ToastContainer />
      <h6 className="mb-4 fw-bold text-primary">Title  Generator</h6>

         {/* Topic Input */}
         <div className="">
        <textarea
          className="form-control"
          placeholder="Enter your topic..."
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          rows={6}
          maxLength={500}
          style={{ borderRadius: "8px", fontSize: "16px", lineHeight: "1.6" }}
        ></textarea>
        <div className="d-flex justify-content-between text-muted mt-2">
          <small>{topic.length}/500 characters</small>
          <small>{topic.trim().split(/\s+/).length} words</small>
        </div>
      </div>
      
      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <label htmlFor="toneSelect" className="form-label fw-bold">
            Select Tone
          </label>
          <Select
            options={toneOptions}
            value={tone}
            onChange={(selectedOption) =>
              selectedOption.value === "custom"
                ? setShowModal(true)
                : setTone(selectedOption)
            }
            getOptionLabel={({ label, icon }) => (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span>{icon}</span>
                {label}
              </div>
            )}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="countrySelect" className="form-label fw-bold">
            Select Language
          </label>
          <Select
            id="countrySelect"
            options={countries}
            onChange={(selected) => setCountry(selected)}
            getOptionLabel={({ label, flag, languages }) => (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <img src={flag} alt={label} style={{ width: "20px", height: "15px" }} />
                <div>
                  <div>{label}</div>
                  <small style={{ color: "#6c757d" }}>{languages}</small>
                </div>
              </div>
            )}
          />
        </div>
      </div>

      <div>
        <button
          onClick={handleGenerateResults}
          className="btn btn-primary"
          disabled={loading}
        >
          <img src={sparkling} alt="sparkling" width={16} height={16} />
          {loading ? "Generating..." : "Generate Title"}
        </button>
      </div>

      {results.length > 0 && (
  <div className="row mt-4">
    {results.map((result, index) => {
      // Split the result into the acronym and its description
      const [acronymPart, ...descriptionParts] = result.split(":");
      const acronym = acronymPart.trim(); // The acronym itself
      const description = descriptionParts.join(":").trim(); // The rest as the description

      return (
        <div key={index} className="col-md-4 mb-4">
          <div
            className="card border shadow-sm"
            style={{
              borderRadius: "12px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <div className="card-body">
              {/* Acronym */}
              <p
                className="card-text"
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "0.5rem",
                }}
              >
                {index + 1}. {acronym}
              </p>

              {/* Description */}
              <p
                className="card-text"
                style={{
                  fontSize: "14px",
                  lineHeight: "1.8",
                  marginBottom: "8px",
                }}
              >
                {description.split(".")[0]}.
              </p>

              {/* Additional Details */}
              <p
                className="card-text"
                style={{
                  fontSize: "13px",
                  lineHeight: "1.6",
                  color: "#6c757d",
                  marginTop: "4px",
                }}
              >
                {description.split(".").slice(1).join(".").trim()}
              </p>

              <button
                className="btn btn-outline-primary btn-sm mt-3"
                onClick={() => handleCopy(result)}
                style={{
                  borderRadius: "8px",
                  fontSize: "13px",
                }}
              >
                Copy
              </button>
            </div>
          </div>
        </div>
      );
    })}
  </div>
)}



      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Custom Tone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="Enter custom tone"
            value={customTone}
            onChange={(e) => setCustomTone(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleCustomToneSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Title;
